/** Referral code from a shared link (`?ref=CODE` on any page), kept for 30 days or until sign-up sends it. */
import { REFERRAL_CODE_RE } from '@platform/shared';

const KEY = 'ref';
const KEEP_MS = 30 * 86_400_000;

export function captureReferral() {
  const code = new URLSearchParams(window.location.search).get('ref');
  if (!code || !REFERRAL_CODE_RE.test(code)) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));
  } catch {
    /* private mode: the code just isn't remembered */
  }
}

export function pendingReferral(): string | undefined {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;
    // Saved before codes had a date: a bare code.
    if (REFERRAL_CODE_RE.test(raw)) return raw;
    const v = JSON.parse(raw) as { code?: unknown; at?: unknown };
    if (typeof v.code !== 'string' || !REFERRAL_CODE_RE.test(v.code) || typeof v.at !== 'number' || Date.now() - v.at > KEEP_MS) {
      localStorage.removeItem(KEY);
      return undefined;
    }
    return v.code;
  } catch {
    return undefined;
  }
}

export function clearReferral() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export const referralLink = (code: string) => `${window.location.origin}/register?ref=${encodeURIComponent(code)}`;
